<template>
    <div class="chat-message-item px-3" :class="{me: isMine}">
        <component v-if="value && author" :is="component" :value="value" :is-mine="isMine" :author="author"></component>
    </div>
</template>
<script>
import Call from '@/components/Messages/Type/Call.vue'
import ChatSpaceCreate from '@/components/Messages/Type/ChatSpaceCreate.vue'
import PcConnectionCreated from '@/components/Messages/Type/PcConnectionCreated.vue'
import Default from '@/components/Messages/Type/Default.vue'
import Question from '@/components/Messages/Type/Question.vue'
import File from '@/components/Messages/Type/File.vue'
export default {
  components: {
    Call,
    ChatSpaceCreate,
    PcConnectionCreated,
    Default,
    Question,
    File
  },
  props: {
    value: {
      type: Object,
      required: true
    },
    author: {
      type: Object,
      required: true
    },
    isMine: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    component () {
      switch (this.value.type) {
        case 'question': return 'question'
        case 'chat_space_create': return 'chat-space-create'
        case 'pc_connection_created': return 'pc-connection-created'
        case 'call': return 'call'
        case 'file': return 'file'
      }
      return 'default'
    }
  }
}
</script>
